<ng-container *ngIf="showDialog$ | async as isVisible">
	<div class="backDrop" *ngIf="isVisible">
		<div class="modal-dialog modal-xl">
			<div class="modal-content ">
				<div>
					<!-- Modal Header -->
					<div class="modal-header ">
						<h4 class="modal-title">JSON result viewer</h4>
						<button (click)="close()">Close</button>
						<button (click)="copyToClipboard()">Copy to clipboard</button>
					</div>

					<div class="flex-container">
						<div class="flex-item flex-item-1" style="max-width: 70%;">
							<div class="modal-body ">
								<!--inhoud-->

								<div *ngIf="_inputJson | async as jsonContent">
									<pre [innerHTML]="jsonContent | prettyjson: [true, 3]"></pre>
								</div>
								<!-- Modal footer -->
							</div>
						</div>
						<div *ngIf="sessionHistory$ | async as sessionHistory">
							<div class="flex-item flex-item-2">
								<!-- Modal body -->
								<div class="option">
									<div>Session history</div>
									<dx-select-box [items]="sessionHistory"
										[inputAttr]="{ 'aria-label': 'Submenu Mode' }" displayExpr="title" (onValueChanged)="selectInstanceHistory($event)"></dx-select-box>
								</div>


							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
